// extracted by mini-css-extract-plugin
export var sliderRange = "_nv-2";
export var sliderRoot = "_nv-0";
export var sliderThumb = "_nv-3";
export var sliderTrack = "_nv-1";